// import { LinkPreview } from "@dhaiwat10/react-link-preview";
import { Box, Typography } from "@material-ui/core";
import { get, isArray } from "lodash";
import ReactPlayer from "react-player";
import { VIDEOPROVIDERS } from "src/constants";
import DisplayVideoLink from "Components/PreviewLink/DisplayVideoLink";
import { defaultAttachmentImage } from "src/utils";
import { saveAs } from "file-saver";
import { Link } from "react-router-dom";
import LinkImg from "Assets/images/file-type/other-types.svg";

export const download = async (url, name) => {
  let imgName = name;
  let blob = await fetch(url).then((r) =>
    r.blob().catch((err) => {
      console.log("error:", err);
    })
  );
  saveAs(blob, imgName);
};

const displayFileImage = (classes, type, attachment) => {
  return (
    <Box
      display="flex"
      position="relative"
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
      width="100%"
      className="rounded border thumbnails"
      p={2}
    >
      <img
        src={type.selectedFileImage}
        alt="thumbnail image"
        className={classes.thumbImg}
        
      />
      <a
        target="_blank"
        href={attachment?.url || attachment}
        className={classes.linkTxt}
      >
        <Typography
          variant="body2"
          className="font-12 font-semibold"
          noWrap="true"
        >
          {get(attachment, "fileName", "")}
        </Typography>
        <Typography variant="body2" className="font-12" noWrap="true">
          {get(type, "attachmentType", "") === "link" ? (
            attachment
          ) : (
            <span className="read-label">(Click to read)</span>
          )}
        </Typography>
      </a>
    </Box>
  );
};

const displayFile = (classes, attachment, isDownload) => {
  return attachment.map((attchmentItem) => {
    let name = get(attchmentItem, "fileName", "");
    const type = defaultAttachmentImage(
      get(attchmentItem, "key", ""),
      attchmentItem
    );

    return (
      <Box
        className={`border added-attachment ${classes.attachmentChip}`}
        mt={0.5}
        mb={0.5}
        px={1}
        py={0.5}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        {attchmentItem?.link && type?.attachmentType === "" ? (
          <Link
            className="truncate-txt cursor-pointer"
            to={{
              pathname: attchmentItem?.link,
            }}
            target="_blank"
          >
            <Box
              display="flex"
              alignItems="center"
              width="87%"
              height="100%"
              className={`${classes.pastedLink} link-txt`}
            >
              <Box height="100%" className={classes.thumbnailImg}>
                <img src={LinkImg} alt="thumbnail image" />
              </Box>
              <Typography
                variant="body2"
                noWrap="true"
                className={classes.fileName}
              >
                {get(attchmentItem, "link", "")}
              </Typography>
            </Box>
          </Link>
        ) : get(type, "attachmentType", "") !== "link" ? (
          <Box
            display="flex"
            alignItems="center"
            width="98%"
            onClick={() => isDownload && download(attchmentItem?.url, name)}
          >
            <Box className={`${classes.thumbnailImg} thumb-img cursor-pointer`}>
              <img
                src={get(type, "selectedFileImage", "")}
                alt="thumbnail image"
                
              />
            </Box>
            <Typography
              variant="body2"
              noWrap="true"
              className={`${classes.fileName} cursor-pointer`}
            >
              {name}
            </Typography>
          </Box>
        ) : (
          <Link
            className="truncate-txt cursor-pointer"
            to={{
              pathname: attchmentItem?.link,
            }}
            onClick={(e) => !isDownload && e.preventDefault()}
            target="_blank"
          >
            <Box
              display="flex"
              alignItems="center"
              width="87%"
              height="100%"
              className={classes.pastedLink}
            >
              <Box
                height="100%"
                className={`${classes.thumbnailImg} thumb-img`}
              >
                <img src={LinkImg} alt="thumbnail image" />
              </Box>
              <Typography
                variant="body2"
                noWrap="true"
                className={`${classes.fileName} cursor-pointer`}
              >
                {get(attchmentItem, "link", "")}
              </Typography>
            </Box>
          </Link>
        )}
      </Box>
    );
  });
};

export const displayAttachments = (
  classes,
  type,
  attachment,
  isDashboard,
  isDownload
) => {
  if (get(type, "attachmentType", "") === "link") {
    const isVideoProvider = VIDEOPROVIDERS.find((i) => attachment.includes(i));
    return isVideoProvider ? (
      <DisplayVideoLink url={attachment} isDashboard={isDashboard} />
    ) : (
      displayFileImage(classes, type, attachment)
    );
  } else if (get(type, "attachmentType", "") === "video") {
    return (
      <ReactPlayer
        url={attachment.url}
        controls={true}
        width="100%"
        height="auto"
        className="react-player"
      />
    );
  } else if (get(type, "attachmentType", "") === "audio") {
    return (
      <ReactPlayer
        url={attachment.url}
        controls={true}
        width="100%"
        height="70px"
        file={{
          forceAudio: true,
        }}
      />
    );
  } else if (get(type, "attachmentType", "") === "image") {
    return (
      <img
        src={type.selectedFileImage}
        alt="checkin attachment"
        className="img-preview"
        
      />
    );
  } else if (isArray(attachment) && attachment?.length > 0) {
    return (
      <>
        <Typography
          variant="body2"
          className="font-bold attachment-label"
          gutterBottom
        >
          Added attachments
        </Typography>
        <div className="file-wrapper">
          {displayFile(classes, attachment, isDownload)}
        </div>
      </>
    );
  } else {
    return displayFileImage(classes, type, attachment);
  }
};
